/* global $ */

import { Controller } from 'stimulus';
import jump from 'jump.js';

const slugify = (str) => (
  str.trim()
    .toLowerCase()
    .replace(' ', '-')
    .replace(/[^(A-z|\d|\-)]/, '')
);

class ChapterBarController extends Controller {
  connect() {
    this.document = document;
    this.isJumping = false;
    this.loadChapters();
  }

  onChapterClick(event) {
    if (this.isJumping) {
      return;
    }

    const id = event.target.getAttribute('data-id');
    const heading = document.getElementById(id);

    this.isJumping = true;

    jump(heading, {
      offset: -80,
      callback: () => {
        this.isJumping = false;
      },
    });
  }

  getHeadingsOnPage() {
    return Array.prototype.slice.call(this.document.querySelectorAll('h2'))
      .map((heading) => {
        let { id } = heading;

        if (typeof id === 'undefined' || !id) {
          id = slugify(heading.textContent);
        }

        heading.id = id;

        return { id, text: heading.textContent.trim() };
      });
  }

  loadChapters() {
    if (!this.targets.has('headings')) {
      return;
    }

    const listItems = this.getHeadingsOnPage().map((item) => `
      <li class="chapter-bar__list-item">
        <button
          type="button"
          class="chapter-bar__item btn--reset"
          data-action="click->chapter-bar#onChapterClick"
          data-id="${item.id}"
        >
          ${item.text}
        </button>
      </li>
    `);

    const activeListItem = this.element.querySelector('li.is-active');

    if (!activeListItem) {
      return;
    }

    const listItemHeadings = activeListItem.querySelector('.chapter-bar__sublist');

    listItemHeadings.innerHTML = listItems.join('');
  }

  onDocumentChange() {
    this.loadChapters();
    this.closeChapterBar();
  }

  closeChapterBar() {
    const chaptersElement = this.element.querySelector('#chapters');
    $(chaptersElement).collapse('hide');
  }
}

ChapterBarController.targets = [
  'active',
  'headings',
];

export default ChapterBarController;
